import axios from 'axios'

export const CompanyGroupApi = {
    list: () => axios.get('/web/company-groups/'),
    create: (companyGroupData) => axios.post('/web/company-groups/', companyGroupData),
    getStatus: (companyGroup) => axios.get(`/web/company-groups/company-group-status/${companyGroup}`)
}
